'use client';

import { FeatureFlagProvider } from 'harness-react';

export default function HarnessFeatureFlagProvider({ children, featureFlagApiKey }) {
  return <FeatureFlagProvider apiKey={featureFlagApiKey}>{children}</FeatureFlagProvider>;
}
